var _defs, _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_cbda143cd2a349bc22549969973ad8c7122978a700cbc8b0dc48ef2cb2f376d9",
    x1: 17.11,
    y1: 69.84,
    x2: 75.36,
    y2: 69.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M74.8 69.69s11.33.85 14.65-1.51C95.36 64 102.23 45.41 108 40.69c3.29-2.68 15-2.14 15-2.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M74.8 70s11.33-.89 14.65 1.56c5.91 4.36 12.78 23.62 18.57 28.51 3.29 2.78 15.57 2.12 15.57 2.12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 18.36,
    y: 62.12,
    width: 55.74,
    height: 15.45,
    rx: 7.47,
    stroke: "url(#SVGID_0_cbda143cd2a349bc22549969973ad8c7122978a700cbc8b0dc48ef2cb2f376d9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M123.51 69.84H82.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M136.86 93.81h5.86M148.67 93.81h5.86M160.4 93.81h5.86M130.67 109.28h5.87M142.48 109.28h5.86M154.21 109.28h5.86M165.99 109.28h5.87M172.14 93.83s3.48.18 5.25 2.5M179.29 101.64a7 7 0 01-2.14 5.38M130.81 93.83s-3.48.18-5.26 2.5M123.66 101.64a7 7 0 002.14 5.36M136.86 93.81h5.86M148.67 93.81h5.86M160.4 93.81h5.86M130.67 109.28h5.87M142.48 109.28h5.86M154.21 109.28h5.86M165.99 109.28h5.87M172.14 93.83s3.48.18 5.25 2.5M179.29 101.64a7 7 0 01-2.14 5.38M130.81 93.83s-3.48.18-5.26 2.5M123.66 101.64a7 7 0 002.14 5.36M142.28 31.01h6.12M156.66 31.01h6.13M147.12 46.45h6.13M132.75 46.45h6.13M161.5 46.45h6.13M171 30.94s3.67-.2 5.74 1.95M179.21 40.37s-.88 3.56-3.55 4.91M125.35 43.85s-2.35-2.85-1.77-5.8M127.94 31.63s1.88-.89 6.07-.61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatRules);
export default __webpack_public_path__ + "static/media/vatRules.23ebec91c3edf1878173ac8b126f548c.svg";
export { ForwardRef as ReactComponent };